import React, { Component } from 'react'
import { Names, ContactPoints, Addresses, OnsetDateTime, Communications } from '../helpers'
import { LiaUserCheckSolid, LiaUserSlashSolid } from 'react-icons/lia'
import { FaFemale, FaMale, FaLanguage } from 'react-icons/fa'
import { FaRegAddressCard } from 'react-icons/fa6'
import { BsFillTelephoneFill } from 'react-icons/bs'
import moment from 'moment'
import './resource.css'

class Patient extends Component {
constructor(props) {
        super(props)

        this.state = {
            isJson: false,
            css: false
        }
    }

    handleJson() {
        this.setState({ css: !this.state.css })
        setTimeout(() => this.setState({ isJson: !this.state.isJson }), 300)
    }

    handleSelect(id) {
        if (this.props.onSelect) this.props.onSelect(id)
    }

    render() {
        //Resource-Container-Patient
        return (
            <div className={`Big-Flip-Container`} onClick={() => this.handleJson()}><div className={`Resource-Container-Patient${this.state.css ? ' Flip' : ''}`}>
            {this.state.isJson ? <div className='Res-Json'><pre>{JSON.stringify(this.props.resource, undefined, 2)}</pre></div> :
                <div>
                <div className="Res-Row">
                    <div className="Res-Title">{this.props.resource.name ? Names(this.props.resource.name) : 'Patient'}</div>
                </div>
                <div className='Res-Row Res-Flex-Spread'>
                    <div style={{ marginRight: '5px' }}>
                        <div className={`Res-Icon ${this.props.resource.active ? 'Res-Icon-Active' : 'Res-Icon-Inactive'}`}>{this.props.resource.active ? <LiaUserCheckSolid /> : <LiaUserSlashSolid />}</div>
                        <div className='Res-Icon-Label'>{this.props.resource.active ? 'Active' : "Inactive"}</div>
                    </div>
                    {this.props.resource.address && <div style={{ marginRight: '5px' }} className='Res-Flex'>
                        <div className={`Res-Icon`} style={{ marginRight: '5px' }}><FaRegAddressCard /></div>
                        <div className='Res-Detail'>{Addresses(this.props.resource.address)}</div>
                    </div>}
                    <div>
                        <div className={`Res-Icon`}>{this.props.resource.gender === 'female' ? <FaFemale /> : <FaMale />}</div>
                        <div className='Res-Icon-Label'>{this.props.resource.gender === 'female' ? 'Female' : "Male"}</div>
                    </div>
                </div>
                <div className='Res-Row Res-Flex-Spread'>
                    <div>
                        {this.props.resource.telecom && <div className='Res-Row'>
                            <span className={`Res-Icon`}><BsFillTelephoneFill /></span>
                            <div className='Res-Detail'>{ContactPoints(this.props.resource.telecom)}</div>
                        </div>}
                    </div>
                    {this.props.resource.birthDate && <div>
                        <div className='Res-Title'>DOB</div>
                        <div className='Res-Detail'>{moment(this.props.resource.birthDate).format('ll')}</div>
                    </div>}
                </div>
                {this.props.resource.communication && <div className='Res-Row'>
                    <span className={`Res-Icon`}><FaLanguage /></span>
                    <div className='Res-Detail'>{Communications(this.props.resource.communication)}</div>
                </div>}
                <div className='Res-Row Res-Flex-Spread'>                    
                    {this.props.resource.deceasedBoolean && <div className='Res-Row Res-Title'>Deceased</div>}
                    {this.props.resource.deceasedDataTime && <div className='Res-Row Res-Title'>Deceased: {OnsetDateTime(this.props.deceasedDataTime)}</div>}
                </div>
            </div>
            }
        </div></div>
        )
    }
}

export default Patient